var map = {
	"./de/warrior-name.png": "IyuF",
	"./en/warrior-name.png": "EGv1",
	"./es/warrior-name.png": "TLlK",
	"./fr/warrior-name.png": "LB2n",
	"./ja/warrior-name.png": "iOmF",
	"./ko/warrior-name.png": "5TW3",
	"./pt/warrior-name.png": "nrlf",
	"./ru/warrior-name.png": "FfdS",
	"./th/warrior-name.png": "JB5N",
	"./zh-Hant/warrior-name.png": "Ame9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+biZ";